import { useMemo } from "react";
import { useCommunitySwitcherContext } from "../context/CommunitySwitcherContext";
import {
  getCommunitySwitcherIconUrl,
  getCommunitySwitcherNotificationCount,
} from "../helpers/communitySwitcherItem";
import { getAutomaticLoginRootUrl } from "../helpers/utils";
import type { CommunitySwitcher } from "../types/CommunitySwitcher";

export const useCommunitySwitcherSidebarItem = (
  community: CommunitySwitcher,
  clickedCommunityId?: number | null,
) => {
  const { api, theme, getNotificationCount, featureFlags } =
    useCommunitySwitcherContext();
  const isDiscoverRouteActive = Boolean(featureFlags?.isDiscoverRouteActive);
  // Once a community has been clicked, the optimistic selection wins so the
  // highlight tracks the click immediately; otherwise fall back to the
  // server-computed current community.
  const isOptimisticActive =
    clickedCommunityId != null
      ? community.id === clickedCommunityId
      : community.is_current_community;
  const isActive = isOptimisticActive && !isDiscoverRouteActive;
  const iconUrl = getCommunitySwitcherIconUrl(
    community,
    theme.isDarkAppearance,
  );
  const notificationCount = getCommunitySwitcherNotificationCount(
    community,
    getNotificationCount,
    "sidebar",
  );
  const href = getAutomaticLoginRootUrl(community.root_url, api.token);
  const isElectron = Boolean(featureFlags?.isElectron);

  const onElectronActivate = useMemo(() => {
    if (!isElectron) {
      return undefined;
    }
    return () =>
      featureFlags?.onElectronChangeCommunity?.({
        href,
        name: community.name,
      });
  }, [community.name, featureFlags, href, isElectron]);

  return {
    href,
    iconUrl,
    isActive,
    isDarkAppearance: theme.isDarkAppearance,
    isElectron,
    notificationCount,
    onElectronActivate,
  };
};
